import { MosyUser, Task } from './types';

/** Lower-case, accents and **bold** markers stripped — so "ducre" finds
 *  "**Wever & Ducré**". */
const fold = (s: string): string =>
  s.replace(/\*\*/g, '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

/** Search tasks by name, campaign name and assignee names. Every word typed
 *  must appear somewhere ("secto report" finds "Secto: send sales report"). */
export const filterTasks = (
  tasks: Task[],
  query: string,
  campaignName: (id: string | null) => string | undefined,
  team: MosyUser[],
): Task[] => {
  const words = fold(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return tasks;
  const people = new Map(team.map((u) => [u.user_id, `${u.display_name} ${u.username} ${u.first_name} ${u.last_name}`]));
  return tasks.filter((t) => {
    const hay = fold([
      t.name,
      campaignName(t.campaign) ?? '',
      ...(t.assignees ?? []).map((id) => people.get(id) ?? ''),
    ].join(' '));
    return words.every((w) => hay.includes(w));
  });
};
